import { initFirebase } from './firebase';
import { reportError } from './error-reporting';

/**
 * Ensure the current user has a fresh authentication token.
 * Refreshes token if it's older than 50 minutes (tokens expire after 1 hour).
 *
 * Shared across all service files to avoid code duplication.
 */
export async function ensureFreshToken(): Promise<void> {
  const { auth } = initFirebase();
  const user = auth.currentUser;

  if (!user) {
    throw new Error('Utilisateur non authentifié');
  }

  try {
    const tokenResult = await user.getIdTokenResult();
    const tokenAge = Date.now() - new Date(tokenResult.issuedAtTime).getTime();
    const fiftyMinutes = 50 * 60 * 1000;

    if (tokenAge > fiftyMinutes) {
      await user.getIdToken(true);
    }
  } catch (error) {
    reportError(error, { context: 'ensureFreshToken', userId: user.uid });
    try {
      await user.getIdToken(true);
    } catch (refreshError) {
      reportError(refreshError, { context: 'ensureFreshToken.fallbackRefresh', userId: user.uid });
      throw refreshError;
    }
  }
}
